import { tw } from '@careinfo/tailwind';
import loadable from '@loadable/component';
import { useParams, useSearchParams } from 'react-router-dom';
import EditIcon from '../Icons/EditIcon';
import APIS from '../constant/EndPoint';
import usePatchHook from '../customHooks/usePatchHook';
import useGetHook from '../customHooks/useGetHook';
import Spinner from '../components/Reusable/Spinner';
import usePostHook from '../customHooks/usePostHook';
import { toast } from 'react-toastify';

const EditCombineOrderComponent = loadable(
  () => import('../components/CombineOrder/EditCombineOrder')
);
const EditCombineOrder = () => {
  const [searchParams, setSearchParms] = useSearchParams();
  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ['combine-order'],
  });
  const { id } = useParams();

  const { data, isLoading: isDataLoading } = useGetHook({
    queryKey: ['combine-order', `combine-order-${id}`],
    params: {},
    url: `${APIS.COMBINE_ORDERS}${id}/`,
  });
  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.COMBINE_ORDERS}${id}/`;
    let formData = {
      ...values,
    };

    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  const { mutateAsync: attachConsignmentMutateAsync, isPostLoading } =
    usePostHook({
      queryKey: ['combine-order-items'],
    });

  const { mutateAsync: removeitems, isPostLoading: isRemoved } = usePostHook({
    queryKey: ['combine-order-items'],
    navigateURL: '',
  });

  const handleRemove = async () => {
    const selectedOrder = searchParams.get('selectedItems')?.split(',');
    if (!selectedOrder?.length) {
      toast.error('Please select at least one order first');
      return;
    }
    const url = `${APIS.COMBINE_ORDER_ITEMS}remove-items/`;
    let formData = {
      items: selectedOrder,
    };
    try {
      const res = await removeitems({ url, formData });
      if (res?.status === 200) {
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleAttachConsignment = async (
    consignmentId: string,

    setError: any
  ) => {
    const url = `${APIS.COMBINE_ORDER_ITEMS}`;
    let formData = {
      combined_order: id,
      tracking_number: consignmentId,
    };
    try {
      await attachConsignmentMutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <EditIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Combined Order
        </span>
      </div>
      {isDataLoading ? (
        <Spinner />
      ) : (
        <EditCombineOrderComponent
          handleEdit={handleEdit}
          isLoading={isLoading}
          handleAttachConsignment={handleAttachConsignment}
          data={data}
          handleRemove={handleRemove}
          isRemoved={isRemoved}
          id={id}
        />
      )}
    </>
  );
};

export default EditCombineOrder;
